import React, { useState } from 'react'
import {
	Button,
	Card,
	CardContent,
	CardHeader,
	Checkbox,
	Collapse,
	FormControl,
	IconButton,
	InputLabel,
	ListItemText,
	makeStyles,
	MenuItem,
	Select,
	TextField,
	useTheme,
	Typography
} from '@material-ui/core'

import { AddOutlined, ExpandMoreOutlined } from '@material-ui/icons'

import { DeletableChip } from '../../Misc/DeletableChip'

import clsx from 'clsx'

import { cloneDeep } from 'lodash'
import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'

const useStyles = makeStyles((theme) => ({
	header: {
		padding: '13px 24px',
		userSelect: 'none',
		cursor: 'pointer',
		'& .MuiCardHeader-action': {
			margin: 0
		}
	},
	grid: {
		display: 'grid',
		gridGap: '23px',
		marginBottom: '23px',
		'&:last-child': {
			marginBottom: 0
		}
	},
	gridDouble: {
		gridTemplateColumns: 'repeat(auto-fill, minmax(424px, 1fr))',
		'& .field-wrapper': {
			'& .MuiTextField-root': {
				minWidth: '424px !important'
			}
		}
	},
	gridTriple: {
		gridTemplateColumns: 'repeat(auto-fill, minmax(274px, 1fr))',
		'& .field-wrapper': {
			'& .MuiTextField-root': {
				minWidth: '274px !important'
			},
			'& .MuiFormControl-root': {
				minWidth: '272px !important'
			}
		}
	},
	fieldWrapper: {
		// '& .MuiTextField-root': {
		//   minWidth: '274px !important'
		// }
	},
	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest
		}),
		padding: 0
	},
	expandOpen: {
		transform: 'rotate(180deg)'
	},
	medication: {
		'& .medication-footer': {
			display: 'flex',
			justifyContent: 'flex-end',
			marginBottom: 16
		},
		'&.last': {
			'& .medication-footer': {
				marginBottom: 0,
				justifyContent: 'space-between'
			}
		}
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
		marginTop: '6px',
		backgroundColor: 'transparent !important'
	},
	timeBlockSelect: {
		textTransform: 'capitalize'
	},
	timeBlock: {
		textTransform: 'capitalize'
	},
	footerButton: {
		fontFamily: 'Nunito',
		fontWeight: '800',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	addMedicationButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	deleteButton: {
		color: '#D32F2F',
		borderColor: '#D32F2F',
		'&:hover': {
			color: '#FFFFFF',
			backgroundColor: '#D32F2F'
		}
	}
}))

const PetMedicationsCard = (props) => {
	const classes = useStyles()
	const theme = useTheme()
	const frequencies = ['Daily', 'As Needed', 'Custom']
	const timeBlocks = ['morning', 'midday', 'evening', 'night']
	let { pet, setPet } = props
	const query = useQuery()
	function useQuery() {
		return new URLSearchParams(useLocation().search)
	}

	const [isExpanded, setIsExpanded] = useState(false)

	useEffect(() => {
		setIsExpanded(query.get('showMedication'))
	}, [])

	const updateMedication = (medication, field, value) => {
		let current = pet.medications
		let medications = cloneDeep(pet.medications)
		let medicationIndex = current.findIndex((m) => m === medication)

		if (medicationIndex !== -1) {
			medications[medicationIndex][field] = value
			setPet({ ...pet, medications })
		}
	}

	const addMedication = () => {
		setPet({
			...pet,
			medications: [
				...pet.medications,
				{
					prescription: '',
					name: '',
					purpose: '',
					frequency: '',
					dosage: '',
					other: '',
					instructions: '',
					times_of_day: [],
					when_to_provide: ''
				}
			]
		})
	}

	const removeTimeBlock = (medication, timeBlock) => {
		let medicationTimeBlocks = [...medication.times_of_day]
		let timeBlockIndex = medicationTimeBlocks.findIndex((time_of_day) => time_of_day === timeBlock)

		if (timeBlockIndex !== -1) {
			medicationTimeBlocks.splice(timeBlockIndex, 1)
			updateMedication(medication, 'times_of_day', medicationTimeBlocks)
		}
	}

	const deleteMedication = (medication) => {
		let medsTodelete = pet.meds_to_delete || []

		if (medication._id) {
			medsTodelete = [...medsTodelete, medication._id]
		}

		let updatedPet = cloneDeep(pet)

		updatedPet = {
			...updatedPet,
			medications: pet.medications.filter((m) => m !== medication)
		}

		if (medsTodelete.length > 0) {
			updatedPet.meds_to_delete = medsTodelete
		}

		setPet(updatedPet)
	}

	return (
		<Card>
			<CardHeader
				title="Medications"
				className={classes.header}
				onClick={() => setIsExpanded(!isExpanded)}
				action={
					<IconButton
						className={clsx(classes.expand, {
							[classes.expandOpen]: isExpanded
						})}
						onClick={() => setIsExpanded(!isExpanded)}
						aria-expanded={isExpanded}
						aria-label="show more">
						<ExpandMoreOutlined style={{ fill: '#777679' }} />
					</IconButton>
				}
			/>
			<Collapse in={isExpanded} timeout="auto" unmountOnExit>
				<CardContent>
					{pet.medications && pet.medications.length ? (
						pet.medications.map((medication, i) => (
							<div
								key={medication._id}
								className={clsx([
									classes.medication,
									i === pet.medications.length - 1 ? 'last' : ''
								])}>
								<Typography variant="body2" style={{ fontWeight: 800, marginBottom: 16 }}>
									Medication {i + 1}
								</Typography>
								<div className={clsx([classes.grid, classes.gridDouble])}>
									<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
										<TextField
											label="Medication Name *"
											variant="filled"
											value={medication.name}
											disabled={!pet.active}
											onChange={(e) => updateMedication(medication, 'name', e.target.value)}
										/>
									</div>
								</div>
								<div className={clsx([classes.grid, classes.gridTriple])}>
									<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
										<TextField
											label="Prescription"
											variant="filled"
											select
											value={medication.prescription}
											disabled={!pet.active}
											onChange={(e) =>
												updateMedication(medication, 'prescription', e.target.value)
											}>
											<MenuItem value={true}>Yes</MenuItem>
											<MenuItem value={false}>No</MenuItem>
										</TextField>
									</div>
									<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
										<TextField
											label="Frequency"
											variant="filled"
											select
											className={classes.frequencySelect}
											value={medication.frequency}
											disabled={!pet.active}
											onChange={(e) =>
												updateMedication(medication, 'frequency', e.target.value)
											}>
											{frequencies.map((frequency) => (
												<MenuItem
													className={classes.frequency}
													key={frequency}
													value={frequency}>
													{frequency}
												</MenuItem>
											))}
										</TextField>
									</div>
									<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
										<FormControl className={classes.select}>
											<InputLabel id="times-of-day-label">Time Block</InputLabel>
											<Select
												labelId="times-of-day-label"
												id="pets-select"
												variant="filled"
												value={medication.times_of_day || []}
												label=">Time Block"
												multiple
												disabled={!pet.active || medication.frequency !== 'Daily'}
												renderValue={(selected) => (
													<div className={classes.chips}>
														{selected.map((value) => (
															<DeletableChip
																key={value}
																disabled={medication.frequency !== 'Daily'}
																label={value}
																className={classes.chip}
																{...{
																	onDelete:
																		medication.frequency === 'Daily'
																			? () =>
																					removeTimeBlock(
																						medication,
																						value
																					)
																			: null
																}}
															/>
														))}
													</div>
												)}
												onChange={(e) =>
													updateMedication(medication, 'times_of_day', e.target.value)
												}>
												{timeBlocks.map((timeBlock) => (
													<MenuItem
														className={classes.timeBlock}
														key={timeBlock}
														value={timeBlock}>
														<Checkbox
															checked={
																medication.times_of_day &&
																medication.times_of_day.indexOf(timeBlock) > -1
															}
														/>
														<ListItemText primary={timeBlock} />
													</MenuItem>
												))}
											</Select>
										</FormControl>
									</div>
								</div>
								<div className={clsx([classes.grid, classes.gridDouble])}>
									<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
										<TextField
											label="Dosage"
											variant="filled"
											disabled={!pet.active}
											value={medication.dosage}
											onChange={(e) =>
												updateMedication(medication, 'dosage', e.target.value)
											}
										/>
									</div>
									<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
										<TextField
											label="Purpose"
											variant="filled"
											disabled={!pet.active}
											value={medication.purpose}
											onChange={(e) =>
												updateMedication(medication, 'purpose', e.target.value)
											}
										/>
									</div>
								</div>
								<div className={classes.grid}>
									<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
										<TextField
											label="Instructions"
											variant="filled"
											fullWidth
											disabled={!pet.active}
											value={medication.instructions}
											onChange={(e) =>
												updateMedication(medication, 'instructions', e.target.value)
											}
										/>
									</div>
								</div>
								<div className={classes.grid}>
									<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
										<TextField
											label="Team Notes"
											variant="filled"
											fullWidth
											disabled={!pet.active}
											value={medication.team_notes}
											onChange={(e) =>
												updateMedication(medication, 'team_notes', e.target.value)
											}
										/>
									</div>
								</div>
								<div className="medication-footer">
									{i === pet.medications.length - 1 ? (
										<Button
											variant="outlined"
											className={clsx(classes.footerButton, classes.addMedicationButton)}
											startIcon={
												<AddOutlined style={{ fill: theme.palette.secondary.main }} />
											}
											size="large"
											disabled={!pet.active}
											onClick={() => addMedication(medication)}>
											Medication
										</Button>
									) : null}
									<Button
										variant="outlined"
										size="large"
										disabled={!pet.active}
										className={clsx([classes.footerButton, classes.deleteButton])}
										onClick={() => deleteMedication(medication)}>
										Delete Medication
									</Button>
								</div>
							</div>
						))
					) : (
						<div>
							<Button
								variant="outlined"
								className={clsx(classes.footerButton, classes.addMedicationButton)}
								startIcon={<AddOutlined style={{ fill: theme.palette.secondary.main }} />}
								size="large"
								disabled={!pet.active}
								onClick={() => addMedication()}>
								Medication
							</Button>
						</div>
					)}
				</CardContent>
			</Collapse>
		</Card>
	)
}

export default PetMedicationsCard
